<template>
<v-container grid-list-xl>
<v-flex xs12>
    <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3">
      <div style="font-size: 27px; font-weight: bold" color="primary">
        <span>&nbsp;</span>
        <v-icon color="primary" size="30px">camera</v-icon>
        <span>Verb Practice I</span>
      </div>
      <v-card-actions>
        <v-card-text>Focus on conjugation.</v-card-text>
      </v-card-actions>
      <v-divider></v-divider>
      <v-select
        :items="componentMap"
        label="Quiz Type"
        solo
        v-model="quizType"
      ></v-select>
      <v-card-actions>
        <v-btn large block round outline color="primary" @click="genSet" :disabled="!quizType"
          >Start</v-btn
        >
      </v-card-actions>
    </v-card>
</v-flex>
<v-flex xs12>
    <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3">
      <div style="font-size: 27px; font-weight: bold" color="primary">
        <span>&nbsp;</span>
        <v-icon color="primary" size="30px">edit</v-icon>
        <span>Verb Practice II</span>
      </div>
      <v-divider></v-divider>

      <v-card-actions>
        <v-card-text>Create your own custom practice session.</v-card-text>
      </v-card-actions>
      <v-btn
        large
        round
        outline
        color="primary"
        to="/practiceconfig"
        >Customize</v-btn
      >
    </v-card>
  </v-flex>
  <v-flex xs12>
    <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3">
      <div style="font-size: 27px; font-weight: bold" color="primary">
        <span>&nbsp;</span>
        <v-icon color="primary" size="30px">edit</v-icon>
        <span>Noun Declension Practice</span>
      </div>
      <v-divider></v-divider>

      <v-card-actions>
        <v-card-text>Practice declining nouns</v-card-text>
      </v-card-actions>
      <v-btn
        large
        round
        outline
        color="primary"
        @click="startNounPractice"
        >Start</v-btn
      >
    </v-card>
  </v-flex>
</v-container>
</template>


<script>
import { VERB_FORMS, VERB_QUESTION_TYPES , PRACTICE_ROUND_LENGTH} from "@/constants.js";
import ParametersToConjugation from "@/components/QuizTypes/ParametersToConjugation";
import ConjugationToParameters from "@/components/QuizTypes/ConjugationToParameters";
import TranslationToConjugation from "@/components/QuizTypes/TranslationToConjugation";
import ConjugationToTranslation from "@/components/QuizTypes/ConjugationToTranslation";
export default {
  data: () => ({
    quizType: null,
    verbQuestionTypes: VERB_QUESTION_TYPES    ,
    componentMap: [
      {
        value: "parameters to conjugation",
        text: "parameters to conjugation",
        type: "parameters to conjugation",
        component: ParametersToConjugation,
      },
      {
        value: "conjugation to parameters",
        text: "conjugation to parameters",
        type: "conjugation to parameters",
        component: ConjugationToParameters,
      },
      {
        value: "translation to conjugation",
        text: "translation to conjugation",
        type: "translation to conjugation",
        component: TranslationToConjugation,
      },
      {
        value: "conjugation to translation",
        text: "conjugation to translation",
        type: "conjugation to translation",
        component: ConjugationToTranslation,
      },
    ],
  }),
  methods: {
    genSet() {
      var obj = {
        forms: VERB_FORMS,
        types: [this.quizType],
      };
      this.$store.dispatch("generatePracticeQuestions",{type: "verb", params: obj})
      this.$router.push("PracticeQuiz/Verb");
    },
    practiceStart(){
      var practiceQueue = _.shuffle(this.$store.getters.availableItems);
      this.$store.commit("setPracticeQueue", practiceQueue.slice(0, PRACTICE_ROUND_LENGTH));
      this.$router.push("PracticeQuiz/Vocab");
    },
    startNounPractice(){
      var practiceQueue = _.shuffle(this.$store.state.vocabulary.filter(x => x.declensions))
      this.$store.commit("setPracticeQueue", practiceQueue.slice(0, PRACTICE_ROUND_LENGTH));
      this.$router.push("PracticeQuiz/noun");
    }
  },
};
</script>
<style scoped>
  .rounded-card {
    border-radius: 10px;
    max-width: 800px;
    margin: 10px auto !important;
  }
</style>